<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_SMS_TEMPLATE')"
      size="lg"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form>
          <validation-observer
            ref="smstemplateform"
            tag="form"
          >
            <b-row>
              <b-col
                v-if="user_type === 'Super Admin'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_COMPANY_NAME')"
                  label-for="title"
                  class="mb-2"
                >
                  <b-form-input
                    id="title "
                    v-model="details.companyName"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="title"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="title "
                      v-model="details.name"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_ENDPOINTS')"
                  label-for="endpoints"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Endpoints"
                    rules="required"
                  >
                    <b-form-input
                      id="endpoints "
                      v-model="details.endpoints"
                      type="text"
                      :placeholder="$t('DEBTIA_ENDPOINTS')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TEMPLATE')"
                  label-for="template"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Template"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="details.content"
                      :placeholder="$t('DEBTIA_TEMPLATE')"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
// import constants from '@/app-configs/constants'
import axiosemail from '../../libs/axiosemail'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  props: {
    templateData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        endpoints: '',
        content: '',
        type: 'sms',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
        companyName: '',
      },
      templateDetails: {
        type: 'sms',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
    }
  },
  watch: {
    templateData: {
      handler() {
        this.details = { ...this.templateData }
      },
    },
  },
  created() {
    this.getCommunicationApiSettings()
  },
  methods: {
    async getCommunicationApiSettings() {
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.communication_client_id = settings.data.data.client_id
          this.communication_secret = settings.data.data.secret
        }
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.smstemplateform.validate().then(success => {
        if (success) {
          const headers = {
            clientId: this.communication_client_id,
            secret: this.communication_secret,
          }
          let url = ''
          if (this.details.id > 0) {
            url = `/template/update-template-api/${this.details.id}`
          } else {
            url = '/template/save-template-api'
          }
          axiosemail.post(url, { ...this.details }, {
            headers,
          }).then(response => {
            if (response.status === 200) {
              this.$nextTick(() => {
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              this.details = {
                id: 0, name: '', endpoints: '', content: '', type: 'sms', user_id: JSON.parse(localStorage.getItem('userData')).data.id,
              }
              this.reloadMethod()
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
